import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { Globals } from 'src/app/globals'
//import { forEach } from '@angular/router/src/utils/collection';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { Message } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { MenuItem, SelectItem } from 'primeng/api';
import { ISPEDSecurityUser } from 'src/app/Models/ISPEDSecurityUser';
import { MaintenanceService } from 'src/app/Services/MaintenanceService';
import { LookupService } from 'src/app/Services/LookupService';
import { IepService } from 'src/app/Services/IepService';
import { AdminPlacementService } from 'src/app/Services/AdminPlacementService';
import { FormPermissionToAssessService } from 'src/app/Services/FormPermissionToAssessService';

import { ILookupBase } from 'src/app/Models/ILookupBase';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { IIepInstance } from 'src/app/Models/IIepInstance';
import { ISPEDSecurityUserRole } from '../../Models/ISPEDSecurityUserRole';
import { ISPEDSecurityUserSite } from '../../Models/ISPEDSecurityUserSite';
import { ISitesSubmitParameter } from '../../Models/ISitesSubmitParameter';
import { Observable, throwError, of } from "rxjs";
import { IIepFormControl } from '../../Models/IIepFormControl';
import { ServicesService } from 'src/app/Services/ServicesService';
import { IServiceAssignment } from '../../Models/IServiceAssignment';
import { IServiceRequestParameters } from '../../Models/IServiceRequestParameters';
import { IStudentMinimal } from 'src/app/Models/IStudentMinimal';
import { ClassStmt } from '@angular/compiler';
import { ISubstituteServiceProvider } from '../../Models/ISubstituteServiceProvider';
import { IAdminPlacement } from '../../Models/IAdminPlacement';
import { IService } from 'src/app/Models/IService';
import { IFormPermissionToAssess } from '../../Models/Forms/IFormPermissionToAssess';
import { MaintenanceLookupTableNameEnum } from '../../Models/Enums/IMaintenanceLookupTableNameEnum';
import { IMaintenanceLookupIdNameIsDeleted } from '../../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedIsActive } from '../../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedCode } from '../../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedFrequency } from '../../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceLookupIdNameIsDeletedDuration } from '../../Models/IMaintenanceLookupIdNameIsDeleted';
import { IMaintenanceInsertUpdateLookupParameter } from '../../Models/IMaintenanceInsertUpdateLookupParameter';
import { IStarIepServiceStaff } from '../../Models/IStarIepServiceStaff';
import { IStaffToServiceProviderCategory,IStaffToServiceProviderCategorySubmit } from '../../Models/IStaffToServiceProviderCategory';
import { ISPEDSecurityUserRoleModifierSubmit } from 'src/app/Models/ISPEDSecurityUserRoleModifierSubmit';

@Component({
  selector: 'maintenance',
  templateUrl: './Maintenance.component.html',
})
export class MaintenanceComponent implements OnInit {
  _baseUrl: string;
  _myGlobals: Globals;
  messages: Message[];
  showSpinner: boolean = false;
  selectedMenuItem: string;
  userNameEmail: string;
  _showCreateNewUserButton: boolean = false;
  _maintenanceService: MaintenanceService;
  _lookupService: LookupService;
  _formPermissionToAssessService: FormPermissionToAssessService;
  servicesService: ServicesService;
  iepService: IepService;
  _localStaffId: string;
  userSecurityRoles: ILookupBase[];
  selectedUserSecurityRole: string;
  selectedStaffToService: string;
  timeStamp: Date;
  iepInstanceArray: IIepInstance[];
  selectedIepInstance: IIepInstance;
  selectedAdminPlacement: IAdminPlacement;
  serviceAssignment: IServiceAssignment;
  serviceAssignments: IServiceAssignment[];
  statusId: number = 1;
  meetingTypeOptions: ILookupBase[];
  meetingStatusOptions: SelectItem[];
  meetingDelayOptions: ILookupBase[];
  disabilityOptions: ILookupBase[];
  lookupSpedServices: ILookupBase[];
  lookupServiceProviderCatagories: ILookupBase[];

  //studentMinimal: IStudentMinimal;
  services: IService[];

  spedSecurityUserSiteDetailsArray: ISPEDSecurityUserSite[];

  sites: ILookupBase[];
  serviceProviders: ILookupBase[];
  matchingServiceProviderArray: ILookupBase[];
  
  selectedSites: string[];
  spedSecurityUserSites: ISPEDSecurityUserSite[];
  
  StaffToServiceProviderCategory: IStaffToServiceProviderCategory[];
  StarIepServiceStaff: IStarIepServiceStaff[];

  selectedSPEDSecurityUser: ISPEDSecurityUser;
  selectedSPEDSecurityUserRole: ISPEDSecurityUserRole;
  selectedSPEDSecurityUserSites: ISPEDSecurityUserSite[];

  selectedStaffToServiceProviderCategory: IStaffToServiceProviderCategory;

  selectedStarIepServiceStaff: IStarIepServiceStaff;
  selectedPTA: IFormPermissionToAssess;
  selectedPTA2: ILookupBase;

  maintenanceMenuItems: MenuItem[];
  maintenanceMenuItemsDisabled: MenuItem[];

  maintenanceLookupItemBaseArray: IMaintenanceLookupIdNameIsDeleted[];
  maintenanceLookupItemReferredByArray: IMaintenanceLookupIdNameIsDeletedCode[];
  maintenanceLookupItemDurationArray: IMaintenanceLookupIdNameIsDeletedDuration[];
  maintenanceLookupItemFrequencyArray: IMaintenanceLookupIdNameIsDeletedFrequency[];
  lookupItemSelectedBase: IMaintenanceLookupIdNameIsDeleted;
  lookupItemSelectedCode: IMaintenanceLookupIdNameIsDeletedCode;
  lookupItemSelectedFrequency: IMaintenanceLookupIdNameIsDeletedFrequency;
  lookupItemSelectedDuration: IMaintenanceLookupIdNameIsDeletedDuration;
  lookupAddInProgress: boolean;

  isUserSecurityVisible: boolean = false;
  isIepInstanceDataVisible: boolean = false;
  isStudentInformationVisible: boolean = false;
  isPTAFormVisible: boolean = false;
  isAdminPlacementVisible: boolean = false;
  isServiceProviderMappingsVisible: boolean = false;
  isStarStudentVisible: boolean = false;
  isLookupMeetingVisible: boolean = false;
  isLookupIndividualGroupVisible: boolean = false;
  isLookupLocationVisible: boolean = false;
  isLookupStatusVisible: boolean = false;
  isLookupReferredByVisible: boolean = false;
  isLookupDurationVisible: boolean = false;
  isLookupFrequencyVisible: boolean = false;
  isSubstituteServiceProvidersVisible: boolean = false;
  substituteServiceProviders: ISubstituteServiceProvider[];
  selectedServiceProviderId: number;
  selectedSubstituteServiceProviderId: number;
  selectedSubstituteStartDate: Date;
  selectedSubstituteEndDate: Date;
  selectedSpedServiceIds: string[];
  selectedServiceProviderCatagoryIds: string[];

  lookupTestArray: ILookupBase[];
  isRoleModifiersVisible : boolean = false;
  selectedSPEDSecurityUserId: number;
  spedSecurityUsers : ILookupBase[];
  spedSecurityRoleModifiersList : ILookupBase[];
  selectedSPEDSecurityRoleModifierIds : string[];

  constructor(
    globals: Globals,
    @Inject('BASE_URL') baseUrl: string,
    maintenanceService: MaintenanceService,
    lookupService: LookupService,
    servicesService: ServicesService,
    iepService: IepService,
    private _apService: AdminPlacementService,
    formPermissionToAssessService: FormPermissionToAssessService
  ) {
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this._maintenanceService = maintenanceService;
    this._lookupService = lookupService;
    this.buildMenuItems();
    this.loadLookupValues();
    this.iepInstanceArray = this._myGlobals.studentIepInstances;
    this.servicesService = servicesService;
    this.iepService = iepService;
    this._formPermissionToAssessService = formPermissionToAssessService;
  }

  ngOnInit(): void {
    this.selectedSPEDSecurityUser = {} as ISPEDSecurityUser;
    this.selectedSPEDSecurityUser.id = -1;
    this.LoadLookupValues();
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.MeetingType]).subscribe((res: any[]) => {
      this.meetingTypeOptions = res as ILookupBase[];
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Status]).subscribe((res: any[]) => {
      let statusArray = res as ILookupBase[];
      let meetingStatusOptions = [];
      for (let option of statusArray) {
        let convertedOption: SelectItem = { value: Number(option.value), label: option.label };
        meetingStatusOptions.push(convertedOption)
      }
      this.meetingStatusOptions = [...meetingStatusOptions];
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.MeetingDelay]).subscribe((res: any[]) => {
      this.meetingDelayOptions = [] as ILookupBase[];
      this.meetingDelayOptions.push({ label: 'If needed, select a Meeting Delay Code', value: '0', shortText: 'If needed, select a Meeting Delay Code', updatedOn: null });
      this.meetingDelayOptions.push.apply(this.meetingDelayOptions, res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceProvider]).subscribe((res: any[]) => {
      this.serviceProviders = [] as ILookupBase[];
      this.serviceProviders.push({ label: 'Select a Service Provider', value: '0', shortText: 'Select a Service Provider', updatedOn: null });
      this.serviceProviders.push.apply(this.serviceProviders, res);
    },
      err => console.error(err)
    );


    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDService]).subscribe((res: any[]) => {
      this.lookupSpedServices = res as ILookupBase[];
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceProviderCategory]).subscribe((res: any[]) => {
      this.lookupServiceProviderCatagories = res as ILookupBase[];
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDSecurityUser]).subscribe((res: any[]) => {
      this.spedSecurityUsers = [] as ILookupBase[];
      this.spedSecurityUsers.push({ label: 'Select a SPEDSecurity User', value: '0', shortText: 'Select a SPEDSecurity User', updatedOn: null });
      this.spedSecurityUsers.push.apply(this.spedSecurityUsers, res);
      this.selectedSPEDSecurityUserId = 0;
    },
      err => console.error(err)
    );

  }

  onLookupIdNameIsDeletedSelected(event) {
    this.lookupItemSelectedBase = event.data as IMaintenanceLookupIdNameIsDeleted;
  }

  onLookupIdNameIsDeletedCodeSelected(event) {
    this.lookupItemSelectedCode = event.data as IMaintenanceLookupIdNameIsDeletedCode
  }

  onLookupDurationSelected(event) {
    this.lookupItemSelectedDuration = event.data as IMaintenanceLookupIdNameIsDeletedDuration
  }

  onLookupFrequencySelected(event) {
    this.lookupItemSelectedFrequency = event.data as IMaintenanceLookupIdNameIsDeletedFrequency
  }

  saveLookupChanges(event, lookupTypeName: string) {
    let lookupParam = {} as IMaintenanceInsertUpdateLookupParameter;

    switch (lookupTypeName) {
      case 'Duration':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Duration
        break;
      case 'Frequency':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Frequency
        break;
      case 'IndividualGroup':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_IndividualGroup
        break;
      case 'Location':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Location
        break;
      case 'Meeting':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Meeting;
        break;
      case 'ReferredBy':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_ReferredBy;
        break;
      case 'Status':
        lookupParam.maintenanceLookupTableNameEnum = MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Status;
        break;
    }

    switch (lookupParam.maintenanceLookupTableNameEnum) {
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_IndividualGroup:
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Location:
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Meeting:
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Status:
        lookupParam.id = this.lookupItemSelectedBase.id;
        lookupParam.name = this.lookupItemSelectedBase.name;
        lookupParam.isDeleted = this.lookupItemSelectedBase.isDeleted;
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_ReferredBy:
        lookupParam.id = this.lookupItemSelectedCode.id;
        lookupParam.name = this.lookupItemSelectedCode.name;
        lookupParam.isDeleted = this.lookupItemSelectedCode.isDeleted;
        lookupParam.code = this.lookupItemSelectedCode.code;
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Duration:
        lookupParam.id = this.lookupItemSelectedDuration.id;
        lookupParam.name = this.lookupItemSelectedDuration.name;
        lookupParam.isDeleted = this.lookupItemSelectedDuration.isDeleted;
        lookupParam.isActive = this.lookupItemSelectedDuration.isActive;
        lookupParam.minutes = this.lookupItemSelectedDuration.minutes;
        break
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Frequency:
        lookupParam.id = this.lookupItemSelectedFrequency.id;
        lookupParam.name = this.lookupItemSelectedFrequency.name;
        lookupParam.isDeleted = this.lookupItemSelectedFrequency.isDeleted;
        lookupParam.isActive = this.lookupItemSelectedFrequency.isActive;
        lookupParam.ordinal = this.lookupItemSelectedFrequency.ordinal;
        lookupParam.frequencyPerMonth = this.lookupItemSelectedFrequency.frequencyPerMonth;
        lookupParam.frequencyPerWeek = this.lookupItemSelectedFrequency.frequencyPerWeek;
        break;
    }


    this.timeStamp = new Date();
    this.messages = null;
    this._maintenanceService.insertUpdateLookupItem(lookupParam).subscribe((res: IMaintenanceLookupIdNameIsDeleted) => {
      let returnItem = res;
      let successMessage: Message = { severity: 'success', summary: 'Lookup Item Saved Successfully.  Record Id: ', detail: res + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
      this.saveLookupChangesPostProcess(lookupParam.maintenanceLookupTableNameEnum);
    },
      err => this.errorHandler(err)
    );

  }

  saveLookupChangesPostProcess(lookupType: MaintenanceLookupTableNameEnum) {
    switch (lookupType) {
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Duration:
        this.getDurationLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Frequency:
        this.getFrequencyLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_IndividualGroup:
        this.getIndividualGroupLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Location:
        this.getLocationLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Meeting:
        this.getMeetingLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_ReferredBy:
        this.getReferredByLookup();
        break;
      case MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Status:
        this.getStatusLookup();
        break;
    }

  }

  addNewLookupItem(lookupTypeName: string) {
    this.lookupAddInProgress = true;

    this.lookupItemSelectedBase = {} as IMaintenanceLookupIdNameIsDeleted;
    this.lookupItemSelectedBase.id = 0;
    this.lookupItemSelectedBase.isDeleted = false;

  }

  cancelLookupItem(lookupTypeName: string) {
    this.lookupItemSelectedBase = {} as IMaintenanceLookupIdNameIsDeleted;
    this.lookupItemSelectedBase.id = 0;
    this.lookupItemSelectedBase.isDeleted = false;

    switch (lookupTypeName) {
      case 'Meeting':
        this.getMeetingLookup();
        break;
      case 'IndividualGroup':
        this.getIndividualGroupLookup();
        break;
      case 'Location':
        this.getLocationLookup();
        break;
      case 'Status':
        this.getStatusLookup();
        break;
    }
  }

  onIepInstanceRowSelect(event) {
    debugger;
    this.selectedIepInstance = event.data as IIepInstance;
    this.selectedIepInstance.meetingDate = this.selectedIepInstance.meetingDate == null ? null : new Date(this.selectedIepInstance.meetingDate);
    this.selectedIepInstance.nextReconveneDate = this.selectedIepInstance.nextReconveneDate == null ? null : new Date(this.selectedIepInstance.nextReconveneDate);
    this.selectedIepInstance.annualDueDate = this.selectedIepInstance.annualDueDate == null ? null : new Date(this.selectedIepInstance.annualDueDate);
    this.selectedIepInstance.triAnnualDueDate = this.selectedIepInstance.triAnnualDueDate == null ? null : new Date(this.selectedIepInstance.triAnnualDueDate);
    this.selectedIepInstance.editedBy = this.selectedIepInstance.editedBy == null ? null : this.selectedIepInstance.editedBy;
    this.selectedIepInstance.editedDate = this.selectedIepInstance.editedDate == null ? null : new Date(this.selectedIepInstance.editedDate);
    this.selectedIepInstance.validatedDate = this.selectedIepInstance.validatedDate == null ? null : new Date(this.selectedIepInstance.validatedDate);
    this.selectedIepInstance.printedDate = this.selectedIepInstance.printedDate == null ? null : new Date(this.selectedIepInstance.printedDate);

    this.selectedIepInstance.statusId = this.selectedIepInstance.statusId;
    this.selectedIepInstance.meetingId = this.selectedIepInstance.meetingId == null ? null : this.selectedIepInstance.meetingId.toString();
    this.selectedIepInstance.meetingDelayCode = this.selectedIepInstance.meetingDelayCode == null ? null : this.selectedIepInstance.meetingDelayCode.toString();

    //time conversion for dates without a calendar control
    this.selectedIepInstance.addendumDate = this.selectedIepInstance.addendumDate == null ? null : new Date(this.selectedIepInstance.addendumDate)
    this.selectedIepInstance.casemisValidationDate = this.selectedIepInstance.casemisValidationDate == null ? null : new Date(this.selectedIepInstance.casemisValidationDate)
    this.selectedIepInstance.nextReconveneDate = this.selectedIepInstance.nextReconveneDate == null ? null : new Date(this.selectedIepInstance.nextReconveneDate)
    this.selectedIepInstance.previousAnnualDueDate = this.selectedIepInstance.previousAnnualDueDate == null ? null : new Date(this.selectedIepInstance.previousAnnualDueDate);
    this.selectedIepInstance.previousTriennialDueDate = this.selectedIepInstance.previousTriennialDueDate == null ? null : new Date(this.selectedIepInstance.previousTriennialDueDate);
  }

  onAdminPlacementRowSelect(event) {
    this.selectedAdminPlacement = event.data as IAdminPlacement;
    this.selectedAdminPlacement.meetingDate = this.selectedAdminPlacement.meetingDate == null ? null : new Date(this.selectedAdminPlacement.meetingDate);
    this.selectedAdminPlacement.statusId = this.selectedAdminPlacement.statusId == null ? null : this.selectedAdminPlacement.statusId;

    //time conversion for dates without a calendar control
    this.selectedAdminPlacement.lastAnnualDate = this.selectedAdminPlacement.lastAnnualDate == null ? null : new Date(this.selectedAdminPlacement.lastAnnualDate);
    this.selectedAdminPlacement.triDueDate = this.selectedAdminPlacement.triDueDate == null ? null : new Date(this.selectedAdminPlacement.triDueDate);
    this.selectedAdminPlacement.verifiedDate = this.selectedAdminPlacement.verifiedDate == null ? null : new Date(this.selectedAdminPlacement.verifiedDate);
    this.selectedAdminPlacement.annualDue = this.selectedAdminPlacement.annualDue == null ? null : new Date(this.selectedAdminPlacement.annualDue);
    this.selectedAdminPlacement.lastTriennial = this.selectedAdminPlacement.lastTriennial == null ? null : new Date(this.selectedAdminPlacement.lastTriennial);
    this.selectedAdminPlacement.participantsAdministratorDesigneeDate = this.selectedAdminPlacement.participantsAdministratorDesigneeDate == null ? null : new Date(this.selectedAdminPlacement.participantsAdministratorDesigneeDate);
    this.selectedAdminPlacement.participantsParentGuardianDate = this.selectedAdminPlacement.participantsParentGuardianDate == null ? null : new Date(this.selectedAdminPlacement.participantsParentGuardianDate);
    this.selectedAdminPlacement.participantsTeacherDate = this.selectedAdminPlacement.participantsTeacherDate == null ? null : new Date(this.selectedAdminPlacement.participantsTeacherDate);
    this.selectedAdminPlacement.participantsOtherDate = this.selectedAdminPlacement.participantsOtherDate == null ? null : new Date(this.selectedAdminPlacement.participantsOtherDate);
    this.selectedAdminPlacement.dateCreated = this.selectedAdminPlacement.dateCreated == null ? null : new Date(this.selectedAdminPlacement.dateCreated);
    this.selectedAdminPlacement.amendsIEPSpecialEdMeetingDate = this.selectedAdminPlacement.amendsIEPSpecialEdMeetingDate == null ? null : new Date(this.selectedAdminPlacement.amendsIEPSpecialEdMeetingDate);
    this.selectedAdminPlacement.amendsIEPSpecialEdAmmendmentDate = this.selectedAdminPlacement.amendsIEPSpecialEdAmmendmentDate == null ? null : new Date(this.selectedAdminPlacement.amendsIEPSpecialEdAmmendmentDate);
  }

  saveIepInstance() {
    this.clearMessages();
    this.timeStamp = new Date();
    this.iepService.insertUpdateIepInstance(this.selectedIepInstance).subscribe((res: IIepInstance) => {
      this.selectedIepInstance = res;
      let successMessage: Message = { severity: 'success', summary: 'IEP Instance Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      err => this.errorHandler(err)
    );
  }

  saveAdminPlacement() {
    this.clearMessages();
    this.timeStamp = new Date();

    this._apService.insertUpdateAdminPlacement(this.selectedAdminPlacement).subscribe((resAp: IAdminPlacement) => {
      this.selectedAdminPlacement = resAp;
      let successMessage: Message = { severity: 'success', summary: 'AP Record Saved Successfully.  Record Id: ', detail: resAp.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      err => this.errorHandler(err)
    )
  }

  buildMenuItems() {
    this.maintenanceMenuItems = [
      { label: 'User Security', command: (event: Event) => { this.menuSelection('User Security') } },
      { label: 'Service Provider Mappings', command: (event: Event) => { this.menuSelection('Service Provider Mappings') } },
      { label: 'Substitute Service Providers', command: (event: Event) => { this.menuSelection('Substitute Service Providers') } },
      { label: 'IEP Instance Data', command: (event: Event) => { this.menuSelection('IEP Instance Data') } },
      { label: 'Admin Placement', command: (event: Event) => { this.menuSelection('Admin Placement') } },
      { label: 'PTA Form', command: (event: Event) => { this.menuSelection('PTA Form') } },
      { label: 'Star_Student Disabilities', command: (event: Event) => { this.menuSelection('Star_Student') } },
      { label: 'Role Modifiers', command: (event: Event) => { this.menuSelection('Role Modifiers') } }

      //{ label: 'Maintain Lookup - Duration', command: (event: Event) => { this.menuSelection('MaintainDuration') } },
      //{ label: 'Maintain Lookup - Frequency', command: (event: Event) => { this.menuSelection('MaintainFrequency') } },
      //{ label: 'Maintain Lookup - Indiv/Group', command: (event: Event) => { this.menuSelection('MaintainIndividualGroup') } },
      //{ label: 'Maintain Lookup - Location', command: (event: Event) => { this.menuSelection('MaintainLocation') } },
      //{ label: 'Maintain Lookup - Meeting', command: (event: Event) => { this.menuSelection('MaintainLookupMeeting') } },
      //{ label: 'Maintain Lookup - ReferredBy', command: (event: Event) => { this.menuSelection('MaintainReferredBy') } },
      //{ label: 'Maintain Lookup - Status', command: (event: Event) => { this.menuSelection('MaintainStatus') } }
      //{ label: 'Student Information', command: (event: Event) => { this.menuSelection('Student Information') } }
    ];
    this.maintenanceMenuItemsDisabled = [
      { label: 'Student Search', command: (event: Event) => { this._myGlobals.selectedIepMenuItem(0); this._myGlobals.stdSerSelected = '' }, disabled: true }
    ];
  }

  loadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDSecurityRole]).subscribe((res: any[]) => {
      this.userSecurityRoles = [] as ILookupBase[];
      this.userSecurityRoles.push({ label: 'Select a Security Role', value: '0', shortText: 'Select a Security Role', updatedOn: null });
      this.userSecurityRoles.push.apply(this.userSecurityRoles, res);
    },
      err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Site]).subscribe((res: any[]) => {
      this.sites = res as ILookupBase[];
    },
      err => console.error(err)
    );


    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Disability]).subscribe((res: any[]) => {
      this.disabilityOptions = [] as ILookupBase[];
      this.disabilityOptions.push({ label: 'Select a Disability', value: '0', shortText: 'Select a Disability', updatedOn: null });
      this.disabilityOptions.push.apply(this.disabilityOptions, res as ILookupBase[]);
    },
      err => console.error(err)
    );

  }

  menuSelection(menuItemName: string) {
    this.messages = null;
    this.selectedMenuItem = menuItemName
    this.selectedAdminPlacement = null;
    this.selectedIepInstance = null;
    this.isUserSecurityVisible = false;
    this.isIepInstanceDataVisible = false;
    this.isStudentInformationVisible = false;
    this.isPTAFormVisible = false;
    this.isAdminPlacementVisible = false;
    this.isServiceProviderMappingsVisible = false;
    this.isStarStudentVisible = false;
    this.isSubstituteServiceProvidersVisible = false;

    this.isLookupDurationVisible = false;
    this.isLookupFrequencyVisible = false;
    this.isLookupIndividualGroupVisible = false;
    this.isLookupLocationVisible = false;
    this.isLookupMeetingVisible = false;
    this.isLookupReferredByVisible = false;
    this.isLookupStatusVisible = false;
    this.isRoleModifiersVisible = false;
    
    this._myGlobals.studentSearchIsVisible = false;

    switch (this.selectedMenuItem) {
      case 'User Security':
        this.isUserSecurityVisible = true;
        break;
      case 'Service Provider Mappings':
        this.isServiceProviderMappingsVisible = true;
        break;
      case 'Substitute Service Providers':
        this.isSubstituteServiceProvidersVisible = true;
        break;
      case 'IEP Instance Data':
        this.isIepInstanceDataVisible = true;
        this._myGlobals.studentSearchIsVisible = true;
        break;
      case 'Admin Placement':
        this.isAdminPlacementVisible = true;
        break;
      case 'Student Information':
        this.isStudentInformationVisible = true;
        break;
      case 'PTA Form':
        this.isPTAFormVisible = true;
        break;
      case 'Star_Student':
        this.isStarStudentVisible = true;
        break;

      case 'MaintainDuration':
        this.isLookupDurationVisible = true;
        this.getDurationLookup();
        break;
      case 'MaintainFrequency':
        this.isLookupFrequencyVisible = true;
        this.getFrequencyLookup();
        break;
      case 'MaintainIndividualGroup':
        this.isLookupIndividualGroupVisible = true;
        this.getIndividualGroupLookup();
        break;
      case 'MaintainLocation':
        this.isLookupLocationVisible = true;
        this.getLocationLookup();
        break;
      case 'MaintainLookupMeeting':
        this.isLookupMeetingVisible = true;
        this.getMeetingLookup();
        break;
      case 'MaintainReferredBy':
        this.isLookupReferredByVisible = true;
        this.getReferredByLookup();
        break;
      case 'MaintainStatus':
        this.isLookupStatusVisible = true;
        this.getStatusLookup();
        break;
      case 'Role Modifiers':
        this.isRoleModifiersVisible = true;
        break;
    }
  }

  lookupSelectionMade() {
    this.maintenanceLookupItemBaseArray = null;
    this.maintenanceLookupItemReferredByArray = null;
    this.maintenanceLookupItemDurationArray = null;
    this.maintenanceLookupItemFrequencyArray = null;
    this.lookupItemSelectedBase = null;
    this.lookupItemSelectedCode = null;
    this.lookupItemSelectedFrequency = null;
    this.lookupItemSelectedDuration = null;
    this.lookupAddInProgress = false;
  }

  getDurationLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupDuration(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Duration).subscribe((res: IMaintenanceLookupIdNameIsDeletedDuration[]) => {
      this.maintenanceLookupItemDurationArray = res as IMaintenanceLookupIdNameIsDeletedDuration[];
    },
      err => console.error(err)
    );
  }

  getFrequencyLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupFrequency(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Frequency).subscribe((res: IMaintenanceLookupIdNameIsDeletedFrequency[]) => {
      this.maintenanceLookupItemFrequencyArray = res as IMaintenanceLookupIdNameIsDeletedFrequency[];
    },
      err => console.error(err)
    );
  }

  getIndividualGroupLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupBase(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_IndividualGroup).subscribe((res: IMaintenanceLookupIdNameIsDeleted[]) => {
      this.maintenanceLookupItemBaseArray = res as IMaintenanceLookupIdNameIsDeleted[];
    },
      err => console.error(err)
    );
  }

  getLocationLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupBase(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Location).subscribe((res: IMaintenanceLookupIdNameIsDeleted[]) => {
      this.maintenanceLookupItemBaseArray = res as IMaintenanceLookupIdNameIsDeleted[];
    },
      err => console.error(err)
    );
  }

  getMeetingLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupBase(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Meeting).subscribe((res: IMaintenanceLookupIdNameIsDeleted[]) => {
      this.maintenanceLookupItemBaseArray = res as IMaintenanceLookupIdNameIsDeleted[];
    },
      err => console.error(err)
    );
  }

  getReferredByLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupReferredBy(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_ReferredBy).subscribe((res: IMaintenanceLookupIdNameIsDeletedCode[]) => {
      this.maintenanceLookupItemReferredByArray = res as IMaintenanceLookupIdNameIsDeletedCode[];
    },
      err => console.error(err)
    );
  }

  getStatusLookup() {
    this.lookupSelectionMade();
    this._maintenanceService.getMaintenanceLookupBase(MaintenanceLookupTableNameEnum.Star_SpecialEd_Lookup_Status).subscribe((res: IMaintenanceLookupIdNameIsDeleted[]) => {
      this.maintenanceLookupItemBaseArray = res as IMaintenanceLookupIdNameIsDeleted[];
    },
      err => console.error(err)
    );
  }

  searchForEmailAddress() {
    this.clearMessages();
    this.selectedUserSecurityRole = '';
    this.selectedSPEDSecurityUser = null;
    this.selectedSPEDSecurityUserRole = null;
    this.selectedSPEDSecurityUserSites = null;
    this.selectedStaffToServiceProviderCategory = null;
    this.selectedStarIepServiceStaff = null;
    this.selectedSites = [];
    this._maintenanceService.getSPEDSecurityUser(this.userNameEmail).subscribe((res: ISPEDSecurityUser) => {
      this.selectedSPEDSecurityUser = res as ISPEDSecurityUser;
      if (Number.isInteger(+this.selectedSPEDSecurityUser.localStaffId)) {
        this._localStaffId = '-- hidden --';
      } else {
        this._localStaffId = this.selectedSPEDSecurityUser.localStaffId;
      }
      if (this.selectedSPEDSecurityUser.firstName == 'UserNameEmail' && this.selectedSPEDSecurityUser.lastName == 'NotFound') {
        let msg: Message = { severity: 'info', summary: 'There is no existing SPED user matching the email address provided (' + this.userNameEmail + ').  If you want to create a new user with the email address you entered, click the "Create New User" button below to proceed.  Otherwise, modify the email address and search again.' };
        this.addMessage(msg);
        this._showCreateNewUserButton = true;
        this.selectedSPEDSecurityUser.id = -1;
        this.selectedSPEDSecurityUser.firstName = '';
        this.selectedSPEDSecurityUser.lastName = '';
      }
      else {
        this.retrieveRelatedUserData();
        this._showCreateNewUserButton = false;
      }
    },
      err => console.error(err)
    );
  }

  retrieveRelatedUserData() {
    this.selectedUserSecurityRole = '';
    this.selectedSites = [] as string[];

    this._maintenanceService.getSPEDSecurityRoleForUser(this.selectedSPEDSecurityUser.id).subscribe((res: ISPEDSecurityUserRole) => {
      this.selectedSPEDSecurityUserRole = res as ISPEDSecurityUserRole;
      for (let userSecurityRole of this.userSecurityRoles) {
        if (userSecurityRole.value == this.selectedSPEDSecurityUserRole.roleId.toString()) {
          this.selectedUserSecurityRole = userSecurityRole.value;
        }
      }
    },
      err => console.error(err)
    );

    this._maintenanceService.getSPEDSecuritySitesForUser(this.selectedSPEDSecurityUser.id).subscribe((res: ISPEDSecurityUserSite[]) => {
      this.spedSecurityUserSites = res as ISPEDSecurityUserSite[],
        this.setSelectedSites()
    },
      err => console.error(err)
    );

    this._maintenanceService.getStaffToServiceProviderCategory(this.selectedStaffToServiceProviderCategory.id).subscribe((res: IStaffToServiceProviderCategory[]) => {
      this.StaffToServiceProviderCategory = res as IStaffToServiceProviderCategory[];
     this.setSelectedSites();
    },
      err => console.error(err)
    );
    this._maintenanceService.getStarIepServiceStaff(this.selectedStarIepServiceStaff.id).subscribe((res: IStarIepServiceStaff[]) => {
      this.StarIepServiceStaff = res as IStarIepServiceStaff[];
     this.setSelectedSites();
    },
      err => console.error(err)
    );
  }

  private setSelectedSites() {
    this.selectedSites = [] as string[];
    for (let userSecuritySite of this.spedSecurityUserSites) {
      for (let possibleSite of this.sites) {
        if (possibleSite.value == userSecuritySite.siteId) {
          this.selectedSites.push(possibleSite.value);
        }
      }
    }
  }

  createNewUser() {
    this.clearMessages();
    this.selectedSPEDSecurityUser.id = 0;
    this.selectedSPEDSecurityUser.userNameEmail = this.userNameEmail;
    this.userNameEmail = '';
    this._showCreateNewUserButton = false;
  }

  saveUser() {
    this.clearMessages();
    this.timeStamp = new Date();
    this._maintenanceService.insertUpdateSPEDSecurityUser(this.selectedSPEDSecurityUser).subscribe((res: ISPEDSecurityUser) => {
      this.selectedSPEDSecurityUser = res;
      let successMessage: Message = { severity: 'success', summary: 'SPED User Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
      this.secondarySaveUser();
    },
      //err => console.error(err)
      err => this.errorHandler(err)
    );
  }

  private secondarySaveUser() {
    // Note: this method is called after the selectedSPEDSecurityUser has been saved.  In the case of inserting a new user, the Id should now be a real (non zero) value
    this.timeStamp = new Date();
    let securityRoleSaveRequired: Boolean = false;
    let sitesSubmitParameter = {} as ISitesSubmitParameter;
    sitesSubmitParameter.sites = this.selectedSites;
    sitesSubmitParameter.spedSecurityUser = this.selectedSPEDSecurityUser;

    if (this.selectedSPEDSecurityUserRole == null) {
      let selectedSPEDSecurityUserRole = {} as ISPEDSecurityUserRole;
      selectedSPEDSecurityUserRole.userId = this.selectedSPEDSecurityUser.id;
      selectedSPEDSecurityUserRole.roleId = +this.selectedUserSecurityRole;
      selectedSPEDSecurityUserRole.startDate = this.timeStamp;
      this.selectedSPEDSecurityUserRole = selectedSPEDSecurityUserRole;
      securityRoleSaveRequired = true;
    }
    else if (this.selectedSPEDSecurityUserRole) {
      let previousRoleId: string
      for (let userSecurityRole of this.userSecurityRoles) {
        if (userSecurityRole.label == this.selectedSPEDSecurityUser.roleName) {
          previousRoleId = userSecurityRole.value;
        }
      }
      if (previousRoleId !== this.selectedUserSecurityRole) {
        let selectedSPEDSecurityUserRole = {} as ISPEDSecurityUserRole;
        selectedSPEDSecurityUserRole.id = this.selectedSPEDSecurityUserRole.id;
        selectedSPEDSecurityUserRole.updatedOn = this.selectedSPEDSecurityUserRole.updatedOn;

        selectedSPEDSecurityUserRole.userId = this.selectedSPEDSecurityUser.id;
        selectedSPEDSecurityUserRole.roleId = +this.selectedUserSecurityRole;
        selectedSPEDSecurityUserRole.startDate = this.timeStamp;
        
        this.selectedSPEDSecurityUserRole = selectedSPEDSecurityUserRole;
        securityRoleSaveRequired = true;
      }
    }

    if (securityRoleSaveRequired) {
      this._maintenanceService.insertUpdateSPEDSecurityUserRole(this.selectedSPEDSecurityUserRole).subscribe((res: ISPEDSecurityUserRole) => {
        this.selectedSPEDSecurityUserRole = res;
        let successMessage: Message = { severity: 'success', summary: 'SPED User Role Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + this.timeStamp.toLocaleTimeString() };
        this.addMessage(successMessage);
      },
        //err => console.error(err)
        err => this.errorHandler(err)
      );
    }

    this._maintenanceService.insertUpdateSPEDSecurityUserSites(sitesSubmitParameter).subscribe((res: ISPEDSecurityUserSite[]) => {
      this.selectedSPEDSecurityUserSites = res;
      let successMessage: Message = { severity: 'success', summary: 'SPED User Site Record(s) Saved Successfully.', detail: 'at ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      //err => console.error(err)
      err => this.errorHandler(err)
    );

  }


  saveServiceProviderSepdandCat() {
    var staffToServiceProviderCategorySubmit = {} as  IStaffToServiceProviderCategorySubmit;
    staffToServiceProviderCategorySubmit.providerCategoryIdsList = this.selectedServiceProviderCatagoryIds;
    staffToServiceProviderCategorySubmit.serviceStaffIdsList = this.selectedSpedServiceIds;
    staffToServiceProviderCategorySubmit.ServiceProviderCategoryId = this.selectedServiceProviderId;

      let selectedSPEDSecurityUserRole = {} as ISPEDSecurityUserRole;
      selectedSPEDSecurityUserRole.id = this.selectedSPEDSecurityUser.id;
      selectedSPEDSecurityUserRole.roleId = +this.selectedUserSecurityRole;
      selectedSPEDSecurityUserRole.startDate = this.timeStamp;
      this.selectedSPEDSecurityUserRole = selectedSPEDSecurityUserRole;
      staffToServiceProviderCategorySubmit.spedSecurityUserRole  = selectedSPEDSecurityUserRole;

    this.clearMessages();
    this._maintenanceService.insertUpdateStaffToServiceProviderCategory(staffToServiceProviderCategorySubmit).subscribe((res: boolean) => {
      let successMessage: Message = { severity: 'success', summary: 'Staff To Service Provider Category and StarIep Service Staff Record(s) Saved Successfully.  Records at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
      this.serviceProviderSelected();  // refreshes the list of service providers
    },
      //err => console.error(err)
      err => this.errorHandler(err)
    );
  }

  saveCategoryMappings() {

  }

  ShowStudentSearch() {
    this._myGlobals.studentSearchIsVisible = true;
    this._myGlobals.selectedStudent = null;
    this._myGlobals.studentMinimal = null;
    this._myGlobals.studentAdminPlacements = null;
    this._myGlobals.studentIepInstances = null;
    this.clearMessages();
  }

  getStudentMinimal() {
    this._maintenanceService.getStudentMinimal(this._myGlobals.selectedStudent.localStudentId).subscribe((res: IStudentMinimal) => {
      this._myGlobals.studentMinimal = res as IStudentMinimal;
    },
      err => console.error(err)
    );
  }

  ptaSelected() {
    if (this.selectedPTA2 != null) {
      if (this.selectedPTA2 == null) {
        this.selectedPTA = null;
      }
      else {
        this.selectedPTA = this._myGlobals.studentPTAs[+this.selectedPTA2];
        this.selectedPTA.firstMailingDate = this.selectedPTA.firstMailingDate == null ? null : new Date(this.selectedPTA.firstMailingDate);
        this.selectedPTA.secondMailingDate = this.selectedPTA.secondMailingDate == null ? null : new Date(this.selectedPTA.secondMailingDate);
        this.selectedPTA.thirdMailingDate = this.selectedPTA.thirdMailingDate == null ? null : new Date(this.selectedPTA.thirdMailingDate);
        this.selectedPTA.signatureDate = this.selectedPTA.signatureDate == null ? null : new Date(this.selectedPTA.signatureDate);
        this.selectedPTA.dateReceivedAtSchool = this.selectedPTA.dateReceivedAtSchool == null ? null : new Date(this.selectedPTA.dateReceivedAtSchool);
      }
    }
  }

  SavePTAChanges() {
    this.timeStamp = new Date();
    this._formPermissionToAssessService.insertUpdateFormPermissionToAssess(this.selectedPTA).subscribe((res: IFormPermissionToAssess) => {
      this.selectedPTA = res;
      let successMessage: Message = { severity: 'success', summary: 'PTA Changes Saved Successfully.  Record Id: ', detail: res.localStudentId + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      err => console.error(err)
    );
   }

  updateStudentDisabilities() {
    this.clearMessages();
    this.timeStamp = new Date();
    this._myGlobals.studentMinimal.primaryDisability = this._myGlobals.primaryDisibility;
    this._myGlobals.studentMinimal.secondaryDisability = this._myGlobals.secondaryDisability = '' ? null : this._myGlobals.secondaryDisability;
    this._myGlobals.studentMinimal.tertiaryDisability = this._myGlobals.tertiaryDisability = '' ? null : this._myGlobals.tertiaryDisability;
    this._myGlobals.studentMinimal.quaternaryDisability = this._myGlobals.quaternaryDisability = '' ? null : this._myGlobals.quaternaryDisability;
    this._maintenanceService.updateStudentDisabilities(this._myGlobals.studentMinimal).subscribe((res: IStudentMinimal) => {
      this._myGlobals.studentMinimal = res as IStudentMinimal;
      let successMessage: Message = { severity: 'success', summary: 'Star_Student Disabilities Saved Successfully.  Record Id: ', detail: res.localStudentId + ' at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
    },
      err => console.error(err)
    );
  }

  serviceProviderSelected() {
    if (this.selectedServiceProviderId != null && this.selectedServiceProviderId > 0) {
      this.selectedSubstituteStartDate = null;
      this.selectedSubstituteEndDate = null;
      this._maintenanceService.getSubstituteServiceProviders(this.selectedServiceProviderId).subscribe((res: ISubstituteServiceProvider[]) => {
        this.substituteServiceProviders = res as ISubstituteServiceProvider[];
      },
        err => console.error(err)
      );

      this._maintenanceService.getServiceProviderSpedServiceIds(this.selectedServiceProviderId).subscribe((res: number[]) => {
        let idArray = res as number[];

        this.selectedSpedServiceIds = [] as string[];

        for (let id of idArray) {
          this.selectedSpedServiceIds.push(id.toString());
        }
      },
        err => {
          console.error(err);
        }
      );

      this._maintenanceService.getServiceProviderCatagoryIds(this.selectedServiceProviderId).subscribe((res: number[]) => {
        let idArray = res as number[];

        this.selectedServiceProviderCatagoryIds = [] as string[];

        for (let id of idArray) {
          this.selectedServiceProviderCatagoryIds.push(id.toString());
        }
      },
        err => {
          console.error(err);
        }
      );

    }
  }

  addSubstitute() {
    let tempSubstitute = {} as ISubstituteServiceProvider;
    tempSubstitute.serviceProviderId = this.selectedServiceProviderId;
    tempSubstitute.substituteServiceProviderId = this.selectedSubstituteServiceProviderId;
    tempSubstitute.startDate = this.selectedSubstituteStartDate;
    tempSubstitute.endDate = this.selectedSubstituteEndDate;

    this._maintenanceService.addSubstituteServiceProvider(tempSubstitute).subscribe((res: ISubstituteServiceProvider) => {
     // tempSubstitute = res as ISubstituteServiceProvider;
      this.selectedSubstituteServiceProviderId = 0;
      this.selectedSubstituteStartDate = null;
      this.selectedSubstituteEndDate = null;
      this.serviceProviderSelected();  // refreshes the list of service providers
    },
      err => console.error(err)
    );

  }

  spedServiceSelected(event) {


  }


  serviceProviderCatagorySelected(event) {


  }
  

  //GetService() {
  //  this.servicesService.getService(48920).subscribe((res: IService) => {
  //    this.service = res as IService
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServices() {
  //  let serviceRequestParameters: IServiceRequestParameters = {} as IServiceRequestParameters;

  //  serviceRequestParameters.adminPlacementId = 19442;
  //  serviceRequestParameters.iepInstanceId = null;

  //  this.servicesService.getServices(serviceRequestParameters).subscribe((res: IService[]) => {
  //    this.services = res as IService[]
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetCurrentServices() {
  //  let localStudentId = 'SCALBL120402F001';

  //  this.servicesService.getCurrentServices(localStudentId).subscribe((res: IService[]) => {
  //    this.services = res as IService[]
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServiceAssignment() {
  //  this.servicesService.getServiceAssignment(36844).subscribe((res: IServiceAssignment) => {
  //    this.serviceAssignment = res as IServiceAssignment
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServiceAssignments() {
  //  let serviceRequestParameters: IServiceRequestParameters = {} as IServiceRequestParameters;

  //  serviceRequestParameters.adminPlacementId = 19397;
  //  serviceRequestParameters.iepInstanceId = null;

  //  this.servicesService.getServiceAssignments(serviceRequestParameters).subscribe((res: IServiceAssignment[]) => {
  //    this.serviceAssignments = res as IServiceAssignment[]
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServiceAssignmentsForStudent() {
  //  this.servicesService.getServiceAssignmentsForStudent('CHASAJ091001M001').subscribe((res: IServiceAssignment[]) => {
  //    this.serviceAssignments = res as IServiceAssignment[]
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServiceLog() {
  //  this.servicesService.getServiceLog(268080).subscribe((res: IServiceLog) => {
  //    this.serviceLog = res as IServiceLog
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //GetServiceLogs() {
  //  this.servicesService.getServiceLogs(36630).subscribe((res: IServiceLog[]) => {
  //    this.serviceLogs = res as IServiceLog[]
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //InsertUpdateService() {
  //  this.service.duration = 3;

  //  this.servicesService.insertUpdateService(this.service).subscribe((res: IService) => {
  //    this.service = res
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //InsertUpdateServiceAssignment() {
  //  this.serviceAssignment.duration = '3';

  //  this.servicesService.insertUpdateServiceAssignment(this.serviceAssignment).subscribe((res: IServiceAssignment) => {
  //    this.serviceAssignment = res
  //  },
  //    //err => console.error(err)
  //    err => this.errorHandler(err)
  //  );
  //}

  //wasServiceAssignmentDeleted: boolean = false;

  //  DeleteServiceAssignment() {

  //    this.servicesService.deleteServiceAssignment(36837).subscribe((res: boolean) => {
  //      this.wasServiceAssignmentDeleted = res
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}


  //matchingServiceProviderArray: ILookupBase[];

  //GetMatchingServiceProviders() {

  //  this.servicesService.getMatchingServiceProviders('NJHS', 331).subscribe((res: ILookupBase[]) => {
  //    this.matchingServiceProviderArray = res
  //  },
  //    err => this.errorHandler(err)
  //  );

  //}

  //InsertUpdateServiceLog() {
  //  this.serviceLog.note = this.serviceLog.note + ' modified by RPW';

  //  this.servicesService.insertUpdateServiceLog(this.serviceLog).subscribe((res: IServiceLog) => {
  //    this.serviceLog = res
  //  },
  //    err => this.errorHandler(err)
  //  );
  //}

  //TestLookups() {

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.Site]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceDuration]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceFrequency]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceIndividualGroup]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceLocation]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDService]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.AbsenceCode]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ServiceProvider]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SessionStatus]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //}

  //GetLookupProgressAttained() {
  //  this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ProgressAttained]).subscribe((res: any[]) => {
  //    this.lookupTestArray = res as ILookupBase[];
  //  },
  //    err => console.error(err)
  //  );

  //}


  errorHandler(error: Response): Observable<any> {
    this.timeStamp = new Date();
    let errorMessage: Message = { severity: 'error', summary: 'An unexpected error occurred: ', detail: error.statusText + ' at: ' + this.timeStamp.toLocaleTimeString() };
    this.addMessage(errorMessage);
    console.log(error);
    return Observable.throw(error);
  }

  addMessage(msg: Message) {
    if (!this.messages)
      this.messages = [] as Message[];
    //this.messages = [...this.messages, msg];
    this.messages.push(msg);
  }

  clearMessages() {
    this.messages = [] as Message[];
  }

  // Start Role Modifiers 

  SPEDSecurityUserSelected(){
    if (this.selectedSPEDSecurityUserId != null && this.selectedSPEDSecurityUserId > 0) {
      
      this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.SPEDSecurityRoleModifier]).subscribe((res: any[]) => {
        this.spedSecurityRoleModifiersList = res as ILookupBase[];
      },
        err => console.error(err)
      );
      
      this._maintenanceService.getSPEDSecurityRoleModifiersForUser(this.selectedSPEDSecurityUserId).subscribe((res: number[]) => {
      let idArray = res as number[];

      this.selectedSPEDSecurityRoleModifierIds = [] as string[];

      for (let id of idArray) {
        this.selectedSPEDSecurityRoleModifierIds.push(id.toString());
      }
      },
        err => {
          console.error(err);
        }
      );
      
    }
  }

  
  saveSPEDSecurityRoleModifiers(){
    this.timeStamp = new Date();
    var spedSecurityUserRoleModifierSubmit = {} as  ISPEDSecurityUserRoleModifierSubmit;
    spedSecurityUserRoleModifierSubmit.SPEDSecurityUserId = this.selectedSPEDSecurityUserId;
    spedSecurityUserRoleModifierSubmit.SPEDSecurityRoleModifiers = this.selectedSPEDSecurityRoleModifierIds;

    this.clearMessages();
    this._maintenanceService.insertUpdateSPEDSecurityUserRoleModifier(spedSecurityUserRoleModifierSubmit).subscribe((res: boolean) => {
      let successMessage: Message = { severity: 'success', summary: 'Spec Secuirity User Role Modifier Record Saved Successfully.  Records at: ' + this.timeStamp.toLocaleTimeString() };
      this.addMessage(successMessage);
      this.SPEDSecurityUserSelected();  // refreshes the list of Spec Secuirity Role Modifiers
    },
      err => this.errorHandler(err)
    );
  }

  // End Role Modifiers 


}
